import Vue from 'vue';
import VueRouter from 'vue-router';
import About from './views/About.vue';
import Events from './views/Events.vue';
import EventDetail from './views/EventDetail.vue';
const SITE_TITLE = 'えいぞうがかり';
Vue.use(VueRouter);
let router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'about',
            component: About,
            meta: {
                title: `ABOUT | ${SITE_TITLE}`,
            },
        },
        {
            path: '/events',
            name: 'Events',
            component: Events,
            /*
              遅延ローディングルート
                - このパスにアクセスが来た時のみの時だけモジュールのロードを行う
                - 遅延ローディングだけだと挙動がおかしいので、ルートパスは必ず初期ロードを行う
                - 画像を使用する場合、遅延ローディングだとコンポーネントを解決できずエラーになる
                  「[Vue warn]: Failed to mount component: template or render function not defined.」
                - 名前付きチャンク：
                    - Code Splittingの機能の一つ
                    - webpackChunkNameに指定した名前でコンポーネントをグループ化してロード
            */
            // component: () => import(/* webpackChunkName: "Events" */ './views/Events.vue'),
            meta: {
                title: `EVENT LIST | ${SITE_TITLE}`,
            },
        },
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: {
                title: `ABOUT | ${SITE_TITLE}`,
            },
        },
        {
            path: '/eventDetail',
            name: 'EventDetail',
            component: EventDetail,
            meta: {
                title: `EVENT | ${SITE_TITLE}`,
            },
        }
    ],
});
router.afterEach((to, from) => {
    /*META情報のタイトルがUNDEFINEでければ、HEADのTITLEに設定する*/
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
});
export default router;
//# sourceMappingURL=router.js.map